import { render, staticRenderFns } from "./settings-help.vue?vue&type=template&id=3d6c4788&"
import script from "./settings-help.ts?vue&type=script&lang=ts&"
export * from "./settings-help.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports